import { CBNAssets } from 'brands/cbn/assets'
import { CBNGOAssets } from 'brands/cbngo/assets'
import { CBNTOAssets } from 'brands/cbnto/assets'
import { CBNTheme } from 'brands/cbn/theme'
import { CBNGOTheme } from 'brands/cbngo/theme'
import { CBNTOTheme } from 'brands/cbnto/theme'
import { DaquiAssets } from 'brands/daqui/assets'
import { DaquiTheme } from 'brands/daqui/theme'
import { OPopularAssets } from 'brands/opopular/assets'
import { OPopularTheme } from 'brands/opopular/theme'
import { TocantinsAssets } from 'brands/tocantins/assets'
import { TocantinsTheme } from 'brands/tocantins/theme'

export type WebsiteTenantDef = {
  assets: any;
  name: string;
  slug: string;
  theme: any;
}

export const WEBSITES: Array<WebsiteTenantDef> = [
  {
    name: 'opopular.d',
    slug: 'opopular',
    theme: OPopularTheme,
    assets: OPopularAssets
  },
  {
    name: 'cbn.d',
    slug: 'cbn',
    theme: CBNTheme,
    assets: CBNAssets
  },
  {
    name: 'cbngo.d',
    slug: 'cbngo',
    theme: CBNGOTheme,
    assets: CBNGOAssets
  },
  {
    name: 'cbnto.d',
    slug: 'cbnto',
    theme: CBNTOTheme,
    assets: CBNTOAssets
  },
  {
    name: 'daqui.d',
    slug: 'daqui',
    theme: DaquiTheme,
    assets: DaquiAssets
  },
  {
    name: 'tocantins.d',
    slug: 'tocantins',
    theme: TocantinsTheme,
    assets: TocantinsAssets
  }
]